import axios from 'axios';
import { Quote } from '../types';

/**
 * Fetches the current quote from the API based on the current hour
 * 
 * @returns Promise that resolves to a Quote object
 * @throws {Error} When the API request fails or returns invalid data
 */
export const fetchQuote = async (): Promise<Quote> => {
  try {
    // Ensure VITE_API_BASE_URL defaults to an empty string if undefined
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';
    const response = await axios.get<Quote>(`${apiBaseUrl}/currentquote`);
    return response.data;
  } catch (error) {
    console.error('Error fetching quote:', error);
    // You might want to throw a more specific error or a custom error type here
    throw new Error('Failed to fetch quote. Please try again later.');
  }
};
